import { useEffect } from 'react';

import { useApolloClient } from '@apollo/react-hooks';
import { useNavigate } from 'react-router-dom';

import useAuth from 'hooks/auth/use-auth';
import { useOrderContext } from 'state/order';
import { useServiceModeContext } from 'state/service-mode';
import { useStoreContext } from 'state/store';
import { routes } from 'utils/routing';

import { REDIRECT_TO_LOGIN } from './constants';

function SignOut() {
  const client = useApolloClient();
  const { signOut } = useAuth();
  const { resetStore } = useStoreContext();
  const { setServiceMode } = useServiceModeContext();
  const navigate = useNavigate();
  const { clearOrderData } = useOrderContext();

  const route = REDIRECT_TO_LOGIN ? routes.signIn : routes.base;

  useEffect(() => {
    signOut().then(() => {
      navigate(route, { state: { isSignOut: true } });
      resetStore();
      setServiceMode(null);
      client.resetStore();
      clearOrderData();
    });
  }, [clearOrderData, client, navigate, resetStore, route, setServiceMode, signOut]);

  return null;
}

export default SignOut;
